import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, Box, PageTabs } from '@livable/saas-react-components';
import { Container, Grid, Paper } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
// import { StatementsBlock } from './StatementsBlock';
import { Balance } from 'src/components/resident/Balance';
import ResidentModal from 'src/components/resident/ResidentModal';
import TenantInformation from 'src/components/tenant/TenantInformation';
import { Transactions } from 'src/components/shared/Transactions';
import TopActionButtons from './TopActionButtons';
import WarningBlock from './WarningBlock';
import useStyles from './styles';
import { useStore } from 'src/stores';
// import { getIntervalBetweenDateAndNow } from 'src/utils/date';
import { useDelay } from 'src/utils/hooks';
import { useURLHandler } from 'src/utils/hooks';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { Bills } from './Bills';
import { Statements } from './Statements';
import { ReccuringChargesTable } from 'src/components/allocations/ReccuringChargesTable';
// import ActivityLogTable from 'src/components/tenant/ActivityLogTable';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { generateAddressString } from 'src/utils/address';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
const ResidentProfilePage = () => {
  var _store$payment$reside;
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accessTokenAsync = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken));
  const COMPANY_ID = accessTokenAsync['custom:companyid'];

  // const balanceStatuses = ['success', 'due', 'critical'];

  const urlParams = new URLSearchParams(location.search);
  const currentAccountId = urlParams.get('accountId');
  const currentPropertyId = urlParams.get('propertyId');
  const currentResidentId = urlParams.get('id');
  const isOpenResidentModal = urlParams.get('openEditModal');
  const scrollTo = urlParams.get('scrollTo'); // ! delete this
  const statementsMonth = urlParams.get('month');
  const statementsYear = urlParams.get('year');
  const params = {
    accountId: currentAccountId,
    id: currentResidentId,
    propertyId: currentPropertyId
  };
  const tabsNames = ['statements', 'transaction-history', 'recurring-transactions'];
  const _useURLHandler = _objectSpread({}, useURLHandler('transaction-history', tabsNames, _objectSpread({}, params))),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const myRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    addresses = _useState4[0],
    setAddresses = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    paperCorrespondenceSetting = _useState6[0],
    setCorrespondenceSetting = _useState6[1];
  const _useState7 = useState('message'),
    _useState8 = _slicedToArray(_useState7, 2),
    activeTab = _useState8[0],
    setActiveTab = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    tenantModalIsOpen = _useState0[0],
    setTenantModalIsOpen = _useState0[1];
  // const [balanceStatus, setBalanceStatus] = useState(balanceStatuses[0]);
  const _useState1 = useState('N/A'),
    _useState10 = _slicedToArray(_useState1, 2),
    propertyName = _useState10[0],
    setPropertyName = _useState10[1];
  const _useState11 = useState(['all']),
    _useState12 = _slicedToArray(_useState11, 2),
    portfolios = _useState12[0],
    setPortfolios = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    triggerRefresh = _useState14[0],
    setTriggerRefresh = _useState14[1];
  const _useState15 = useState({
      id: 'N/A',
      email: 'N/A',
      phone: 'N/A',
      newEmail: null,
      lastName: 'N/A',
      firstName: 'N/A',
      emailConfirmed: true,
      portalAccessDateOnly: null
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    userProfileData = _useState16[0],
    setUserProfileData = _useState16[1];
  const _useState17 = useState({
      billingEndDateOnly: 'N/A',
      billingStartDateOnly: 'N/A',
      leaseEndDateOnly: 'N/A',
      leaseStartDateOnly: 'N/A',
      occupancy: 'N/A',
      unitName: 'N/A'
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    residencyOverviewData = _useState18[0],
    setResidencyOverviewData = _useState18[1];
  const openTenantModal = tab => {
    setActiveTab(tab);
    setTenantModalIsOpen(true);
  };
  const executeScroll = tab => {
    handleSelectedTabChange(tab ? tab : 'statements');
    myRef.current.scrollIntoView();
  };
  const getAccountBalance = async () => {
    const resp = await store.payment.getAccountBalanceAsync.run({
      accountId: currentAccountId
    });
    return resp;
  };
  const getFSEInfos = async () => {
    const resp = await store.fse.getFSEInfosAsync.run({
      residencyIds: [currentResidentId]
    });
    return resp;
  };
  const getProperty = async data => {
    const resp = await store.properties.getPropertyAsync.run(data);
    return resp;
  };
  const getResidencyMoveOutDate = async data => {
    const resp = await store.residencies.getResidencyMoveOutDateAsync.run(data);
    return resp;
  };
  const getResidencyOverview = async data => {
    const resp = await store.residencies.getResidencyOverviewByResidencyIdAsync.run(data);
    return resp;
  };
  const getUserProfile = async data => {
    const resp = await store.account.getUsersProfilesAsync.run(data);
    return resp;
  };
  const fetchResidencyPaperCorrespondenceSetting = async () => {
    const respPaperCorrespondenceSetting = await store.residencies.getResidencyPaperCorrespondenceSettingAsync.run({
      residencyId: currentResidentId
    });
    if (respPaperCorrespondenceSetting !== null && respPaperCorrespondenceSetting !== void 0 && respPaperCorrespondenceSetting.isSuccessful) {
      setCorrespondenceSetting(respPaperCorrespondenceSetting.response);
    }
  };
  const fecthAddresses = async () => {
    const data = [];
    const residencyAddressesResp = await store.residencies.getResidencyAddressesAsync.run({
      residencyId: currentResidentId
    });
    const residencyAddressesIds = residencyAddressesResp.response.map(i => i.addressId);
    const addressResp = await store.address.batchGetAddressesAsync.run({
      addressIds: residencyAddressesIds
    });
    residencyAddressesResp.response.map(i => {
      const cData = i;
      cData.details = addressResp.response.find(e => e.addressId === i.addressId);
      data.push(cData);
    });
    setAddresses(data);
  };
  const fetchData = () => {
    if (!currentResidentId || !currentAccountId) {
      navigate('/');
      return;
    }
    setIsDataLoading(true);
    getResidencyMoveOutDate({
      residencyId: currentResidentId
    }).then(async resp => {
      var _propertyDataAsync$re;
      if (!resp) {
        setIsDataLoading(false);
        return;
      }
      const propertyDataAsync = await getProperty({
        propertyId: currentPropertyId
      });
      setPropertyName(generateAddressString(propertyDataAsync === null || propertyDataAsync === void 0 ? void 0 : propertyDataAsync.response.address));
      setPortfolios((propertyDataAsync === null || propertyDataAsync === void 0 || (_propertyDataAsync$re = propertyDataAsync.response) === null || _propertyDataAsync$re === void 0 ? void 0 : _propertyDataAsync$re.portfolioIds) || ['all']);
      const userProfileDataAsync = await getUserProfile({
        accountIds: [currentAccountId]
      });
      setUserProfileData({
        accountCode: singleElementOfArray(userProfileDataAsync.response).accountCode,
        email: singleElementOfArray(userProfileDataAsync.response).email,
        newEmail: singleElementOfArray(userProfileDataAsync.response).newEmail,
        phone: singleElementOfArray(userProfileDataAsync.response).phone,
        lastName: singleElementOfArray(userProfileDataAsync.response).lastName,
        firstName: singleElementOfArray(userProfileDataAsync.response).firstName,
        emailConfirmed: singleElementOfArray(userProfileDataAsync.response).emailConfirmed,
        portalAccessDateOnly: singleElementOfArray(userProfileDataAsync.response).portalAccessDateOnly
      });
      const residencyOverviewDataAsync = await getResidencyOverview({
        residencyId: currentResidentId
      });
      setResidencyOverviewData({
        billingEndDateOnly: residencyOverviewDataAsync.response.billingEndDateOnly,
        billingStartDateOnly: residencyOverviewDataAsync.response.billingStartDateOnly,
        leaseEndDateOnly: residencyOverviewDataAsync.response.leaseEndDateOnly,
        leaseStartDateOnly: residencyOverviewDataAsync.response.leaseStartDateOnly === '0001-01-01' || residencyOverviewDataAsync.response.leaseStartDateOnly === null || residencyOverviewDataAsync.response.leaseStartDateOnly === 'null' ? null : residencyOverviewDataAsync.response.leaseStartDateOnly,
        occupancy: residencyOverviewDataAsync.response.occupancy,
        unitName: residencyOverviewDataAsync.response.unitName
      });
      await getAccountBalance();
      await store.allocations.getCurrentCycleAsync.run({
        companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
      });
      await store.payment.getAutopayMethodByAccountIdAsync.run({
        accountId: currentAccountId
      });
      await fetchResidencyPaperCorrespondenceSetting();
      await getFSEInfos();
      await fecthAddresses();

      // const currentInterval = getIntervalBetweenDateAndNow(
      //   store.payment.residentBalance.dueOnDateOnly
      // );

      // if (currentInterval <= 1) {
      //   setBalanceStatus(balanceStatuses[2]);
      // } else if (currentInterval > 1 && currentInterval <= 10) {
      //   setBalanceStatus(balanceStatuses[1]);
      // }
    });
    if (isOpenResidentModal === 'true') {
      setTimeout(() => {
        setIsDataLoading(false);
        openTenantModal('personal-details');
      }, 3000);
    } else {
      setIsDataLoading(false);
    }
    if (scrollTo === 'statements') myRef.current.scrollIntoView();
    setTriggerRefresh(false);
  };
  useEffect(() => {
    fetchData();
    return () => {
      store.residencies.resetLeaseDetails();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (triggerRefresh) fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerRefresh]);
  useDelay(getAccountBalance, [store.transaction.updateData], 700);
  const name = userProfileData.firstName !== 'N/A' && userProfileData.lastName !== 'N/A' && (userProfileData.firstName || userProfileData.lastName) ? "".concat(userProfileData.firstName, " ").concat(userProfileData.lastName) : t('resident_account.resident_account_profile');
  const breadcrumbArray = [{
    title: t('general.dashboard'),
    link: '/active_dashboard'
  }, {
    link: "/active_dashboard/".concat(COMPANY_ID, "/").concat(portfolios[0], "/").concat(currentPropertyId, "/residents"),
    title: propertyName
  }, {
    title: name
  }];
  const tabs = [{
    value: 'transaction-history',
    label: t('resident_account.transaction_history')
  }, {
    label: 'Statements',
    value: 'statements'
  },
  // {
  //   value: 'statements',
  //   label: 'Old Statements',
  // },
  {
    value: 'recurring-transactions',
    label: t('resident_account.recurring_transactions')
  }
  // {
  //   value: 'account-analytics',
  //   label: 'Account analytics',
  // },
  ];
  // if (store.account.featureFlagsStore.getIsActivityLogsEnabled) {
  //   tabs.push({
  //     value: 'activity-log',
  //     label: 'Activity log',
  //   });
  // }

  const closeTenantModal = () => {
    setTriggerRefresh(true);
    setTenantModalIsOpen(false);
  };
  const handleChange = (e, newValue) => handleSelectedTabChange(newValue);
  const handleRefreshTrigger = () => setTriggerRefresh(!triggerRefresh);
  const getTab = () => {
    switch (selectedTab) {
      case 'statements-old':
        return /*#__PURE__*/React.createElement(Statements, {
          accountId: currentAccountId,
          predefinedData: statementsYear || statementsMonth ? {
            year: statementsYear,
            month: statementsMonth
          } : false,
          residencyId: currentResidentId,
          userProfileData: userProfileData
        });
      case 'recurring-transactions':
        return /*#__PURE__*/React.createElement(ReccuringChargesTable, {
          accountId: currentAccountId,
          triggerRefresh: triggerRefresh
        });
      case 'transaction-history':
        return /*#__PURE__*/React.createElement(Transactions, {
          propertyId: currentPropertyId,
          residencyId: currentResidentId,
          accountId: currentAccountId,
          overviewData: residencyOverviewData,
          triggerRefresh: triggerRefresh,
          setTriggerRefresh: setTriggerRefresh
        });
      case 'statements':
      default:
        return /*#__PURE__*/React.createElement(Bills, {
          accountId: currentAccountId,
          predefinedData: statementsYear || statementsMonth ? {
            year: statementsYear,
            month: statementsMonth
          } : false,
          propertyId: currentPropertyId,
          residencyId: currentResidentId,
          setTriggerRefresh: setTriggerRefresh,
          userProfileData: userProfileData
        });
      // case 'activity-log':
      //   return <ActivityLogTable />;
    }
  };
  const changeStatus = async function (id) {
    let decline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let cStatus = 'Approved';
    if (decline) cStatus = 'Declined';
    const resp = await store.residencies.updateResidencyAddressStatusAsync.run({
      residencyId: currentResidentId,
      residencyAddressId: id,
      status: cStatus
    });
    await fecthAddresses();
    if (resp && resp.response) toast('success', {
      body: ['Successfully saved']
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray
  }), store.residencies.moveOutDateOnly ? /*#__PURE__*/React.createElement("div", {
    className: classes.warningWrapper
  }, /*#__PURE__*/React.createElement(WarningBlock, {
    date: store.residencies.moveOutDateOnly,
    executeScroll: executeScroll,
    isFinalStatementEstimationEnabled: store.account.featureFlagsStore.isFinalStatementEstimationEnabled,
    openTenantModal: openTenantModal,
    propertyId: currentPropertyId,
    residencyId: currentResidentId,
    unitName: residencyOverviewData.unitName,
    userProfileData: userProfileData
  })) : null, /*#__PURE__*/React.createElement(Box, {
    className: "".concat(classes.pageWrapper, "  ").concat(!store.residencies.moveOutDateOnly ? classes.pageWrapperTopPadding : null)
  }, /*#__PURE__*/React.createElement(Container, null, store.residencies.moveOutDateOnly ? /*#__PURE__*/React.createElement(TopActionButtons, {
    openTenantModal: openTenantModal,
    handleRefreshTrigger: handleRefreshTrigger
  }) : /*#__PURE__*/React.createElement(TopActionButtons, {
    creditModal: {
      accountId: currentAccountId,
      propertyId: currentPropertyId
    },
    openTenantModal: openTenantModal,
    handleRefreshTrigger: handleRefreshTrigger,
    showMoveOut: true
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.tenantInfoPaper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 20,
    rowSpacing: 20,
    className: classes.tenantInfoContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React.createElement(TenantInformation, {
    addresses: addresses,
    accountId: currentAccountId,
    data: userProfileData,
    overviewData: residencyOverviewData,
    action: openTenantModal,
    residencyId: currentResidentId,
    propertyName: propertyName,
    changeStatus: changeStatus,
    paperCorrespondenceSetting: paperCorrespondenceSetting
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React.createElement(Balance, {
    accountId: currentAccountId,
    propertyId: currentPropertyId,
    residencyId: currentResidentId,
    status: (_store$payment$reside = store.payment.residentBalance) === null || _store$payment$reside === void 0 ? void 0 : _store$payment$reside.accountBalanceStatus,
    handleRefreshTrigger: handleRefreshTrigger
  }))), /*#__PURE__*/React.createElement("div", {
    ref: myRef
  })))), /*#__PURE__*/React.createElement(PageTabs, {
    handleSelectedTabChange: handleChange,
    selectedTab: selectedTab,
    tabs: tabs
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, getTab()), /*#__PURE__*/React.createElement(ResidentModal, {
    isOpen: tenantModalIsOpen,
    handleOpen: openTenantModal,
    handleClose: closeTenantModal,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    accountId: currentAccountId,
    residencyId: currentResidentId,
    noOuterFooter: true,
    activeResidency: propertyName,
    unitName: '',
    propertyId: currentPropertyId
  })), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isDataLoading
  }));
};
export default ResidentProfilePage;